import type { AdminAiWeeklyReviews } from '@steado/admin-contract/ai-ops';

export function fallbackRateOf(reviews: AdminAiWeeklyReviews): number | null {
  const asked = reviews.model + reviews.fallback;
  return asked === 0 ? null : reviews.fallback / asked;
}
